import React, { memo, useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { Button } from '@saleshandy/design-system';
import RadioButtonGroup from '../../../../../../../../shared/design-system/components/radio-button-group';
import { VoiceMailIcon } from '../../../../../../../../shared/svg';
import type { IProps } from './types';

const EnableVoicemailGreetingModal: React.FC<IProps> = ({
  show,
  onClose,
  onSubmit,
}) => {
  const [greetingAction, setGreetingAction] = useState<'enable' | 'disable'>(
    'enable',
  );

  // Reset state when modal closes
  useEffect(() => {
    if (!show) {
      setGreetingAction('enable');
    }
  }, [show]);

  const handleConfirm = () => {
    onSubmit?.(greetingAction === 'enable');
    onClose();
  };

  const handleCancel = () => {
    setGreetingAction('enable');
    onClose();
  };

  return (
    <Modal
      show={show}
      onHide={handleCancel}
      aria-labelledby="enable-voicemail-greeting-modal-title"
      className="enable-voicemail-greeting-modal"
      backdrop="static"
      centered
    >
      <Modal.Header className="enable-voicemail-greeting-modal__header">
        <div className="enable-voicemail-greeting-modal__header-content">
          <VoiceMailIcon
            width={20}
            height={20}
            className="enable-voicemail-greeting-modal__header-icon"
          />
          <Modal.Title
            id="enable-voicemail-greeting-modal-title"
            className="enable-voicemail-greeting-modal__title"
          >
            Bulk Voicemail Greeting Settings
          </Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body className="enable-voicemail-greeting-modal__body">
        <RadioButtonGroup
          name="voicemail-greeting-action"
          value={greetingAction}
          onChange={(value) => setGreetingAction(value)}
          className="enable-voicemail-greeting-modal__radio-group"
          options={[
            {
              label: 'Enable voicemail greeting for all selected numbers',
              value: 'enable',
            },
            {
              label: 'Disable voicemail greeting for all selected numbers',
              value: 'disable',
            },
          ]}
        />
      </Modal.Body>
      <Modal.Footer className="enable-voicemail-greeting-modal__footer">
        <div className="enable-voicemail-greeting-modal__footer-actions">
          <Button
            onClick={handleCancel}
            variant="secondary"
            className="enable-voicemail-greeting-modal__cancel-btn"
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleConfirm}
            className="enable-voicemail-greeting-modal__confirm-btn"
          >
            Confirm
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default memo(EnableVoicemailGreetingModal);
